import { parameters } from './options';
import { SubscriptionType } from './Display/IConfig';

export function getApplicationVersion() {
	const PATHNAME_REGEXP = /\/((\d+\.\d+\.\d+)(-[^\/]+)?)\/index\.html$/;
	const path = window.location.pathname;
	const matches = path.match(PATHNAME_REGEXP);
	if (!matches) {
		return parameters.app.version;
	}
	return matches[1];
}

export function getSubscriptionType(): SubscriptionType {
	if (parameters.subscriptionType && parameters.subscriptionType in SubscriptionType) {
		return parameters.subscriptionType as SubscriptionType;
	}
	return SubscriptionType.open;
}
